import { render, staticRenderFns } from "./DetailsDebit.vue?vue&type=template&id=50894a33&scoped=true"
import script from "./DetailsDebit.vue?vue&type=script&lang=js"
export * from "./DetailsDebit.vue?vue&type=script&lang=js"
import style0 from "./DetailsDebit.vue?vue&type=style&index=0&id=50894a33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50894a33",
  null
  
)

export default component.exports